import { AccountRoleAndPrivilegesWebController } from '../controller/AccountRoleAndPrivilegesWebController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { AccountActionContext } from '../../types/AccountActionContext';
import { Observable } from 'rxjs';
import { isHidden } from '../../../../utils/htmlElement.utils';
import { CompanyData } from '../../types/CompanyData';
import { AccountRoleAndPrivilegesData, Rights } from '../type';

export class AccountRoleAndPrivilegesWebComponent extends BaseWebComponentElement {
  public controller!: AccountRoleAndPrivilegesWebController;
  private viewData: AccountRoleAndPrivilegesData;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AccountRoleAndPrivilegesWebController,
    });
  }

  public setViewData(accountData: AccountRoleAndPrivilegesData): void {
    this.viewData = accountData;
  }

  public getViewData(): AccountRoleAndPrivilegesData {
    return this.viewData;
  }

  public setActionContext(context: AccountActionContext): void {
    this.controller.view.context = context;
  }

  async updateSettingsDependingOnCompany(company: CompanyData): Promise<void> {
    this.controller.view.currentSelectedCompany = company;
    await this.controller.updateRoleOptions(company);
  }

  public getSelectedRoleId(): string | null {
    return this.controller.view.dom.$roleDropdown.selectedOption?.value !== ''
      ? (this.controller.view.dom.$roleFormField.value as string)
      : null;
  }

  public getSelectedRights(): Rights {
    return {
      companyManager: this.controller.view.dom.$manageCompanyRightFormField.value as boolean,
      manageCompanies:
        this.dependencies.isCloud() && !isHidden(this.controller.view.dom.$manageCompaniesRightFormField)
          ? (this.controller.view.dom.$manageCompaniesRightFormField.value as boolean)
          : false,
      manageInventory: this.controller.view.dom.$manageInventoryRightFormField.value as boolean,
      managePoliciesRead: this.controller.view.dom.$managePoliciesReadRightFormField.value as boolean,
      managePoliciesWrite: this.controller.view.dom.$managePoliciesWriteRightFormField.value as boolean,
      managePlatform: !this.dependencies.isCloud()
        ? (this.controller.view.dom.$manageSolutionRightFormField.value as boolean)
        : false,
      manageReports: this.controller.view.dom.$manageReportsRightFormField.value as boolean,
      manageUsers: this.controller.view.dom.$manageUsersFormField.value as boolean,
      manageRemoteShell: this.dependencies.isCloud()
        ? (this.controller.view.dom.$advancedInvestigationRightFormField.value as boolean)
        : false,
    };
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get valid(): boolean {
    if (!this.controller.view.formGroup) {
      return false;
    }
    return this.controller.view.formGroup.valid;
  }

  public mustSelectTargets(): boolean {
    return this.controller.view.checkIfUserMustSelectTargets();
  }

  public hasUserSelectedRightsOnlyForCompanies(): boolean {
    return this.controller.hasUserSelectedRightsOnlyForCompanies();
  }

  public hasUserSelectedRightsForNetworkTargets(): boolean {
    return this.controller.hasUserSelectedRightsForNetwork();
  }
}
